<template>
    <CustomAutocomplete :completeFunction="searchController" :emptyValue="false" :dropdown="dropdown" v-model="internalValue"
                        :name="name" :label="label" :width="width" :customErrorMessage="customErrorMessage"
                        :itemFromQuery="false" :disabled="disabled" :required="required" :field="searchParam"
                        :showErrors="showErrors" completeOnFocus :rules="rules"/>
</template>

<script>
import {searchControllerByPhrase} from "@/swagger/vue-api-client";
    import CustomAutocomplete from "./inner/CustomAutocomplete";
import {useField} from "vee-validate";
import {watch} from "vue";

    export default {
        name: "CustomAutocompleteVeterinarian",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            modelValue: null,
            searchParam: {
                type: String,
                default: "name",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            customErrorMessage: {
                type: String,
                default: "",
            },
            showErrors: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            dropdown: {
                type: Boolean,
                default: false,
            },
            width: {
                type: String,
                default: null,
            },
            rules: undefined,
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() { return this.modelValue; },
                set(value) { this.$emit("update:modelValue", value === "" ? null : value); },
            },
        },

        data() {
            return {
                items: [],
                selectedValue: null,
                searchController: async (obj) => {
                    const { query } = obj;
                    return searchControllerByPhrase({phrase: query});
                },
            };
        },

        components: {CustomAutocomplete},

        setup(props) {
            const {
                value: inputValue,
                errorMessage,
                handleBlur,
                handleChange,
                meta,
                setValue,
            } = useField(props.name, props.rules, {
                initialValue: props.modelValue,
            });

            watch(
                () => props.modelValue,
                (newValue) => {
                    setValue(newValue);
                }
            );

            return {
                handleChange,
                handleBlur,
                errorMessage,
                inputValue,
                meta,
            };
        },
    };
</script>

<style scoped>

</style>
